var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAltia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 183.008,
    height: 63.027,
    viewBox: "0 0 183.008 63.027",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Altia",
    "data-name": "Logo Altia",
    transform: "translate(-2.647 -2.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-239-Copy",
    transform: "translate(2.647 2.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M16.8-4.245,10.181-19.1l-.481.241L16.315-4a1.8,1.8,0,0,1,.481-.241",
    transform: "translate(8.763 21.746)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M13.4-2.627,5.281-16.7l-.481.3L12.919-2.326a3.357,3.357,0,0,0,.481-.3",
    transform: "translate(10.716 20.79)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M10.283-.589.721-13.7.3-13.4,9.8-.228c.18-.12.3-.241.481-.361",
    transform: "translate(12.51 19.594)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    d: "M20.293-5.544,15.241-21l-.541.18L19.752-5.363l.541-.18",
    transform: "translate(6.77 22.504)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    d: "M27.725-7.022,26.041-23.2l-.541.06L27.184-6.962c.18,0,.361-.06.541-.06",
    transform: "translate(2.465 23.38)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    d: "M24.009-6.463,20.641-22.4l-.541.12L23.468-6.342a1.756,1.756,0,0,1,.541-.12",
    transform: "translate(4.618 23.062)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    d: "M7.306,1.788-3.579-10.3-4-9.939,6.885,2.149c.12-.12.3-.241.421-.361",
    transform: "translate(14.224 18.239)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    d: "M-2.924,17.292-18.32,12.3l-.18.541,15.4,4.992a.97.97,0,0,1,.18-.541",
    transform: "translate(20.004 9.23)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    d: "M-4,20.968-19.88,17.6l-.12.541,15.817,3.368A1.911,1.911,0,0,0-4,20.968",
    transform: "translate(20.601 7.118)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    d: "M-4.622,24.684-20.74,23l-.06.541,16.118,1.684c0-.18.06-.361.06-.541",
    transform: "translate(20.92 4.965)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    d: "M31.241-7.2h.3V-23.5H31V-7.2h.241",
    transform: "translate(0.273 23.5)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-23",
    d: "M4.649,4.385-7.439-6.5l-.361.421L4.288,4.806c.06-.18.241-.3.361-.421",
    transform: "translate(15.739 16.724)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-25",
    d: "M-4.822,28.821V28.4H-21v.541H-4.822v-.12",
    transform: "translate(21 2.813)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-27",
    d: "M-1.6,13.715-16.4,7.1l-.3.541,14.855,6.615a2.136,2.136,0,0,1,.241-.541",
    transform: "translate(19.286 11.303)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-29",
    d: "M.113,10.419-13.9,2.3l-.3.481L-.127,10.9c.06-.18.18-.3.241-.481",
    transform: "translate(18.29 13.216)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-31",
    d: "M2.211,7.262-10.9-2.3l-.3.421L1.971,7.683a2.615,2.615,0,0,0,.241-.421",
    transform: "translate(17.094 15.05)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-33",
    d: "M50.261,4.806,62.349-6.079,61.988-6.5,49.9,4.385a2.616,2.616,0,0,1,.361.421",
    transform: "translate(-7.26 16.724)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-35",
    d: "M54.641,14.3,69.435,7.681,69.195,7.2,54.4,13.815a1.209,1.209,0,0,1,.241.481",
    transform: "translate(-9.054 11.263)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-37",
    d: "M51.961,7.783,65.132-1.779l-.3-.421L51.6,7.3c.12.18.241.3.361.481",
    transform: "translate(-7.938 15.01)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-39",
    d: "M53.441,10.9,67.513,2.781l-.3-.481L53.2,10.419c.06.18.18.3.241.481",
    transform: "translate(-8.576 13.216)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-41",
    d: "M56.76,25.225l16.118-1.684L72.818,23,56.7,24.684a1.665,1.665,0,0,0,.06.541",
    transform: "translate(-9.971 4.965)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-43",
    d: "M56.28,21.509,72.1,18.141l-.12-.541L56.1,20.968a1.912,1.912,0,0,1,.18.541",
    transform: "translate(-9.732 7.118)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-45",
    d: "M55.58,17.833l15.4-4.992L70.8,12.3,55.4,17.292l.18.541",
    transform: "translate(-9.453 9.23)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-47",
    d: "M34.141-6.962,35.825-23.14l-.541-.06L33.6-7.022c.18,0,.361.06.541.06",
    transform: "translate(-0.763 23.38)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-49",
    d: "M41.781-4,48.4-18.859l-.481-.241L41.3-4.245A1.8,1.8,0,0,1,41.781-4",
    transform: "translate(-3.832 21.746)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-51",
    d: "M39.341-5.363,44.333-20.88,43.792-21,38.8-5.544l.541.18",
    transform: "translate(-2.836 22.504)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-53",
    d: "M36.741-6.342,40.109-22.28l-.541-.12L36.2-6.463a1.756,1.756,0,0,1,.541.12",
    transform: "translate(-1.8 23.062)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-55",
    d: "M44.181-2.326,52.3-16.4l-.481-.3L43.7-2.627a3.358,3.358,0,0,0,.481.3",
    transform: "translate(-4.789 20.79)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-57",
    d: "M48.421,2.149,59.306-9.939l-.421-.361L48,1.788c.12.12.3.241.421.361",
    transform: "translate(-6.503 18.239)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-59",
    d: "M46.381-.228,55.943-13.4l-.421-.3L45.9-.589c.18.12.3.241.481.361",
    transform: "translate(-5.666 19.594)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-61",
    d: "M55.6,36.841l15.336,4.992.18-.541L55.78,36.3l-.18.541",
    transform: "translate(-9.532 -0.336)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-63",
    d: "M46.1,49.7l9.442,12.99.421-.3L46.521,49.4c-.12.06-.241.18-.421.3",
    transform: "translate(-5.746 -5.557)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-65",
    d: "M48.2,47.961,58.965,59.929l.421-.361L48.621,47.6c-.12.12-.3.241-.421.361",
    transform: "translate(-6.583 -4.84)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-67",
    d: "M43.8,51.141l8.059,13.893.481-.241L44.281,50.9a3.573,3.573,0,0,1-.481.241",
    transform: "translate(-4.829 -6.155)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-69",
    d: "M38.9,53.38l4.992,15.276.541-.18L39.441,53.2l-.541.18",
    transform: "translate(-2.876 -7.072)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-71",
    d: "M36.3,54.02l3.368,15.7.541-.12L36.841,53.9c-.18.06-.361.06-.541.12",
    transform: "translate(-1.839 -7.351)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-73",
    d: "M50.1,46.121,62.068,56.886l.361-.421L50.461,45.7a2.616,2.616,0,0,0-.361.421",
    transform: "translate(-7.34 -4.083)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-75",
    d: "M41.4,52.341l6.555,14.674.481-.241L41.941,52.1a2.136,2.136,0,0,1-.541.241",
    transform: "translate(-3.872 -6.634)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-77",
    d: "M56.9,28.4V29H73.078V28.46H56.9Z",
    transform: "translate(-10.05 2.813)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-79",
    d: "M56.7,31.641l16.058,1.684.06-.541L56.76,31.1a1.665,1.665,0,0,1-.06.541",
    transform: "translate(-9.971 1.737)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-81",
    d: "M33.6,54.46,35.284,70.4l.541-.06L34.141,54.4a1.665,1.665,0,0,0-.541.06",
    transform: "translate(-0.763 -7.55)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-83",
    d: "M56.3,34.241l15.817,3.368.12-.541L56.42,33.7a1.756,1.756,0,0,0-.12.541",
    transform: "translate(-9.811 0.7)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-85",
    d: "M53.3,41.781,67.253,49.84l.3-.481L53.6,41.3c-.12.18-.18.3-.3.481",
    transform: "translate(-8.615 -2.329)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-87",
    d: "M51.8,44.021l13.051,9.442.3-.421L52.161,43.6c-.12.12-.241.3-.361.421",
    transform: "translate(-8.018 -3.246)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-89",
    d: "M54.6,39.381l14.734,6.555.241-.481L54.78,38.9c-.06.18-.12.3-.18.481",
    transform: "translate(-9.134 -1.372)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-91",
    d: "M16.2,52.1,9.7,66.774l.481.241,6.555-14.674A2.136,2.136,0,0,1,16.2,52.1",
    transform: "translate(8.763 -6.634)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-93",
    d: "M1.751,43.6-11.3,53.042l.3.421L2.051,44.021a1.827,1.827,0,0,0-.3-.421",
    transform: "translate(17.134 -3.246)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-95",
    d: "M4.108,45.7-7.8,56.465l.361.421L4.529,46.121a2.779,2.779,0,0,0-.421-.421",
    transform: "translate(15.739 -4.083)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-97",
    d: "M-.247,41.3-14.2,49.359l.3.481L.053,41.781a2.11,2.11,0,0,1-.3-.481",
    transform: "translate(18.29 -2.329)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-99",
    d: "M6.765,47.6-4,59.568l.421.361L7.186,47.961c-.12-.12-.3-.241-.421-.361",
    transform: "translate(14.224 -4.84)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-101",
    d: "M-4.183,33.7-20,37.068l.12.541,15.817-3.368c-.06-.12-.06-.361-.12-.541",
    transform: "translate(20.601 0.7)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-103",
    d: "M-1.966,38.9-16.7,45.455l.241.481,14.734-6.555a1.8,1.8,0,0,0-.241-.481",
    transform: "translate(19.286 -1.372)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-105",
    d: "M31.2,54.6h-.3V70.658h.541V54.6H31.2",
    transform: "translate(0.313 -7.63)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-107",
    d: "M-3.164,36.3-18.5,41.292l.18.541,15.336-4.992a.97.97,0,0,1-.18-.541",
    transform: "translate(20.004 -0.336)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-109",
    d: "M9.642,49.4.2,62.39l.481.3L10.123,49.7a2.11,2.11,0,0,0-.481-.3",
    transform: "translate(12.55 -5.557)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-111",
    d: "M27.184,54.4,25.5,70.337l.541.06L27.725,54.46a1.665,1.665,0,0,0-.541-.06",
    transform: "translate(2.465 -7.55)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-113",
    d: "M19.692,53.2,14.7,68.476l.541.18L20.233,53.38l-.541-.18",
    transform: "translate(6.77 -7.072)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-115",
    d: "M23.408,53.9,20.1,69.6l.541.12,3.368-15.7c-.241-.06-.421-.06-.6-.12",
    transform: "translate(4.618 -7.351)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-117",
    d: "M-4.642,31.1-20.7,32.784l.06.541,16.058-1.684a1.665,1.665,0,0,1-.06-.541",
    transform: "translate(20.88 1.737)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-119",
    d: "M12.859,50.9,4.8,64.793l.481.3L13.34,51.141a3.572,3.572,0,0,1-.481-.241",
    transform: "translate(10.716 -6.155)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-121",
    d: "M4.71,4.085-7.378-6.8l-.722.842L3.988,4.927a3.165,3.165,0,0,1,.722-.842",
    transform: "translate(15.858 16.843)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-123",
    d: "M2.232,6.962-10.938-2.6l-.662.9L1.571,7.864a5.853,5.853,0,0,1,.662-.9",
    transform: "translate(17.253 15.169)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-125",
    d: "M.214,10.019-13.859,1.9l-.541.962L-.387,10.981c.18-.3.421-.662.6-.962",
    transform: "translate(18.369 13.376)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-127",
    d: "M7.327,1.488-3.558-10.6l-.842.722L6.485,2.21a10.471,10.471,0,0,0,.842-.722",
    transform: "translate(14.383 18.358)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-129",
    d: "M10.264-.829.7-14l-.9.662L9.423-.168a8.085,8.085,0,0,1,.842-.662",
    transform: "translate(12.709 19.713)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-131",
    d: "M13.481-2.827,5.362-16.9l-.962.541L12.579-2.286l.9-.541",
    transform: "translate(10.876 20.869)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-133",
    d: "M-3.982,20.468-19.859,17.1l-.241,1.083L-4.223,21.55c.06-.361.18-.722.241-1.083",
    transform: "translate(20.641 7.317)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-135",
    d: "M-1.524,13.315-16.379,6.7-16.8,7.722l14.855,6.615a3.681,3.681,0,0,1,.421-1.022",
    transform: "translate(19.326 11.462)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-137",
    d: "M76.443,2.862,75.9,1.9l-.6.361.541.962Z",
    transform: "translate(-17.385 13.376)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-141",
    transform: "translate(0 30.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-139",
    d: "M-4.822-22.238V-22.9H-21v1.083H-4.822v-.421",
    transform: "translate(21 22.9)",
    fill: "#072132",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-142",
    d: "M-2.983,16.892-18.439,11.9l-.361,1.022,15.4,4.992c.18-.361.3-.722.421-1.022",
    transform: "translate(20.123 9.39)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-144",
    d: "M16.838-4.445,10.222-19.3,9.2-18.879,15.815-4.024a5.2,5.2,0,0,0,1.022-.421",
    transform: "translate(8.962 21.826)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-146",
    d: "M-4.562,24.184-20.68,22.5l-.12,1.083,16.118,1.684a6.627,6.627,0,0,1,.12-1.083",
    transform: "translate(20.92 5.165)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-148",
    d: "M57.7-9.489l2.766-3.849L59.627-14,56.8-10.151Z",
    transform: "translate(-10.011 19.713)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-150",
    d: "M52.762-11.126l3.007-5.232-.962-.541L51.8-11.728Z",
    transform: "translate(-8.018 20.869)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-152",
    d: "M47.922-12.2l2.947-6.676-.962-.421L46.9-12.624Z",
    transform: "translate(-6.064 21.826)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-154",
    d: "M62.582-7.232l2.406-2.646-.782-.722L61.8-7.954Z",
    transform: "translate(-12.004 18.358)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-156",
    d: "M-4.782,30.7-20.9,32.384l.12,1.083,16.058-1.684a6.537,6.537,0,0,0-.06-1.083",
    transform: "translate(20.96 1.896)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-158",
    d: "M43.322-12.66l2.646-8.179L44.946-21.2,42.3-13.021Z",
    transform: "translate(-4.231 22.583)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-160",
    d: "M20.194-6.345,15.383-21.2l-1.083.361L19.171-6.045Z",
    transform: "translate(6.93 22.583)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-162",
    d: "M23.69-8.247,20.683-22.5l-1.083.241L22.667-8.006Z",
    transform: "translate(4.817 23.101)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-164",
    d: "M27.526-9.828,26.083-23.3,25-23.18,26.443-9.708Z",
    transform: "translate(2.665 23.42)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-166",
    d: "M30.5-11.111h1.083V-23.5H30.5Z",
    transform: "translate(0.472 23.5)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-168",
    d: "M36.285-23.18,35.2-23.3,34-12.174l1.083.12Z",
    transform: "translate(-0.923 23.42)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-169",
    d: "M41.127-22.259,40.045-22.5,38-12.817l1.083.18Z",
    transform: "translate(-2.517 23.101)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-170",
    d: "M71.2,58.3l1.2.9.662-.9-1.2-.9Z",
    transform: "translate(-15.75 -8.746)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-171",
    d: "M42.3,65.161l2.646,8.179,1.022-.361L43.322,64.8Z",
    transform: "translate(-4.231 -11.696)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-172",
    d: "M46.9,65.721,49.907,72.4l.962-.421L47.922,65.3Z",
    transform: "translate(-6.064 -11.895)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-173",
    d: "M51.8,65.641l3.007,5.232.962-.541L52.762,65.1Z",
    transform: "translate(-8.018 -11.815)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-174",
    d: "M34,62.52l1.2,11.126,1.083-.12L35.083,62.4Z",
    transform: "translate(-0.923 -10.739)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-175",
    d: "M38,64.041l2.045,9.683,1.083-.241L39.083,63.8Z",
    transform: "translate(-2.517 -11.297)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-176",
    d: "M56.8,64.962l2.827,3.849.842-.662L57.7,64.3Z",
    transform: "translate(-10.011 -11.496)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-177",
    d: "M30.5,73.089h1.083V60.7H30.5Z",
    transform: "translate(0.472 -10.062)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-178",
    d: "M61.8,63.522l2.406,2.646.782-.722L62.582,62.8Z",
    transform: "translate(-12.004 -10.899)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-179",
    d: "M71.2-1.7l.662.842,1.2-.842L72.4-2.6Z",
    transform: "translate(-15.75 15.169)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-180",
    d: "M75.3,54.662l.6.361.541-.962-.6-.361Z",
    transform: "translate(-17.385 -7.271)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-181",
    d: "M66.6-5.116l.782.782,1.8-1.684L68.464-6.8Z",
    transform: "translate(-13.917 16.843)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-182",
    d: "M66.6,61.282l1.864,1.684.722-.782-1.8-1.684Z",
    transform: "translate(-13.917 -9.982)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-183",
    d: "M1.551,43.2-11.5,52.642l.662.9L2.212,44.1a4.309,4.309,0,0,1-.662-.9",
    transform: "translate(17.213 -3.086)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-184",
    d: "M-4.183,33.3-20,36.668l.241,1.083,15.817-3.368A6.993,6.993,0,0,1-4.183,33.3",
    transform: "translate(20.601 0.86)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-185",
    d: "M-.447,40.9-14.4,48.959l.541.962L.094,41.862c-.18-.3-.361-.662-.541-.962",
    transform: "translate(18.369 -2.169)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-186",
    d: "M6.465,47.3-4.3,59.268l.842.722L7.307,48.022a10.47,10.47,0,0,1-.842-.722",
    transform: "translate(14.343 -4.72)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-187",
    d: "M3.868,45.3-8.1,56.125l.722.842L4.59,46.142a4.85,4.85,0,0,1-.722-.842",
    transform: "translate(15.858 -3.923)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-188",
    d: "M-2.066,38.5-16.8,45.055l.421,1.022,14.734-6.615a6.682,6.682,0,0,1-.421-.962",
    transform: "translate(19.326 -1.213)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-189",
    d: "M-3.364,35.9-18.7,40.892l.361,1.022L-3,36.922c-.12-.3-.241-.662-.361-1.022",
    transform: "translate(20.083 -0.176)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-190",
    d: "M19.171,53.8,14.3,68.595l1.083.361L20.194,54.1Z",
    transform: "translate(6.93 -7.311)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-191",
    d: "M22.667,56.2,19.6,70.453l1.083.241L23.69,56.441Z",
    transform: "translate(4.817 -8.268)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-192",
    d: "M25,71.972l1.083.12L27.526,58.62l-1.083-.12Z",
    transform: "translate(2.665 -9.185)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-193",
    d: "M15.8,52,9.3,66.674l1.022.421,6.555-14.674c-.421-.12-.722-.3-1.083-.421",
    transform: "translate(8.923 -6.594)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-194",
    d: "M9.342,49.1-.1,62.09l.9.662,9.442-12.99c-.3-.241-.6-.421-.9-.662",
    transform: "translate(12.669 -5.438)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-195",
    d: "M12.459,50.6,4.4,64.553l.962.541L13.421,51.2a5.193,5.193,0,0,1-.962-.6",
    transform: "translate(10.876 -6.036)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-196",
    d: "M279.661-7.68l.421,1.864h.662L281.1-7.68v1.864h.361V-7.8h-.722L280.383-6l-.361-1.8H279.3v1.985h.361Z",
    transform: "translate(-98.698 17.242)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-197",
    d: "M276.722-5.815h.361V-7.5h.722v-.3H276v.3h.722Z",
    transform: "translate(-97.382 17.242)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-198",
    d: "M123.527-5.094h.6L129.6,6.273H118.234ZM122.985-7.8,116.069,6.273H112.1V8.137h3.067L112.1,14.392h2.466l2.887-6.255h13.111l3.007,6.255h3.248L126.053-7.8Z",
    transform: "translate(-32.053 17.242)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-199",
    d: "M161.787-7.8H158.9V14.392h17.742V12.347H161.787Z",
    transform: "translate(-50.707 17.242)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-200",
    d: "M188.3-5.815h8.059V14.392h2.887V-5.815H207.3V-7.8h-19Z",
    transform: "translate(-62.426 17.242)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-201",
    d: "M228.6,14.392h2.887V-7.8H228.6Z",
    transform: "translate(-78.489 17.242)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-202",
    d: "M253.627-5.094h.6L259.7,6.273H248.334ZM263.67,14.392h3.248l-3.007-6.255h3.007V6.273h-3.909L256.153-7.8h-3.067L242.2,14.392h2.466l2.887-6.255h13.111Z",
    transform: "translate(-83.91 17.242)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-203",
    d: "M113.422,56.494a2.364,2.364,0,0,1-1.022-.541l.421-.9a3.187,3.187,0,0,0,.9.481,3.405,3.405,0,0,0,1.083.18,1.608,1.608,0,0,0,1.022-.241.661.661,0,0,0,.361-.6.546.546,0,0,0-.18-.421,1.209,1.209,0,0,0-.481-.241c-.18-.06-.481-.12-.782-.241a8.718,8.718,0,0,1-1.143-.361,1.642,1.642,0,0,1-.722-.541,1.53,1.53,0,0,1-.3-.962,1.477,1.477,0,0,1,.3-.9,1.889,1.889,0,0,1,.842-.662,3.169,3.169,0,0,1,1.383-.241,6.627,6.627,0,0,1,1.083.12,4.656,4.656,0,0,1,.962.421l-.361.9a2.109,2.109,0,0,0-.842-.361,4.718,4.718,0,0,0-.842-.12,1.721,1.721,0,0,0-1.022.241.666.666,0,0,0-.3.6.546.546,0,0,0,.18.421,1.209,1.209,0,0,0,.481.241c.18.06.481.12.782.241.481.12.842.241,1.143.3a1.642,1.642,0,0,1,.722.541,1.53,1.53,0,0,1,.3.962,1.477,1.477,0,0,1-.3.9,1.89,1.89,0,0,1-.842.662,3.169,3.169,0,0,1-1.383.241,3.709,3.709,0,0,1-1.443-.12",
    transform: "translate(-32.172 -5.916)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-204",
    d: "M128.353,56.734v-4.09l-2.045,3.368h-.481L123.783,52.7v4.029H122.7V50.6h.962l2.406,4.029,2.406-4.029h.962v6.134Z",
    transform: "translate(-36.278 -6.036)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-205",
    d: "M139.99,54.389l-1.143-2.646L137.7,54.389Zm.421.9h-3.067l-.6,1.443H135.6l2.766-6.134h1.143l2.766,6.134h-1.2Z",
    transform: "translate(-41.42 -6.036)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-206",
    d: "M151.808,51.863a1.992,1.992,0,0,0-1.143-.3h-1.323v2.466h1.323a2.139,2.139,0,0,0,1.143-.3.972.972,0,0,0,.361-.9A1.27,1.27,0,0,0,151.808,51.863Zm.421,4.871-1.263-1.8h-1.624v1.8H148.2V50.6h2.526a3.343,3.343,0,0,1,1.383.241,1.858,1.858,0,0,1,.9.722,2.3,2.3,0,0,1,.3,1.143,2.032,2.032,0,0,1-.361,1.2,1.66,1.66,0,0,1-.962.722l1.383,1.985h-1.143Z",
    transform: "translate(-46.442 -6.036)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-207",
    d: "M159.945,51.562H157.9V50.6h5.172v.962h-1.985v5.172h-1.143Z",
    transform: "translate(-50.308 -6.036)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-208",
    d: "M173.664,56.254a2.622,2.622,0,0,1-1.143-1.143,3.342,3.342,0,0,1,0-3.248,3.149,3.149,0,0,1,1.2-1.143,3.872,3.872,0,0,1,1.684-.421,3.528,3.528,0,0,1,1.383.241,2.23,2.23,0,0,1,1.022.782l-.722.662a2.059,2.059,0,0,0-1.624-.722,2.487,2.487,0,0,0-1.143.3,1.645,1.645,0,0,0-.782.782,2.1,2.1,0,0,0,0,2.165,1.955,1.955,0,0,0,.782.782,2.487,2.487,0,0,0,1.143.3,2.059,2.059,0,0,0,1.624-.722l.722.722a2.783,2.783,0,0,1-1.083.782,3.528,3.528,0,0,1-1.383.241,2.685,2.685,0,0,1-1.684-.361",
    transform: "translate(-55.968 -5.916)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-209",
    d: "M183.6,56.734h1.143V50.6H183.6Z",
    transform: "translate(-60.552 -6.036)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-210",
    d: "M189.245,51.562H187.2V50.6h5.172v.962h-2.045v5.172h-1.083Z",
    transform: "translate(-61.987 -6.036)",
    fill: "#072132",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-211",
    d: "M200.348,54.569v2.165h-1.143V54.569L196.8,50.6H198l1.8,3.007,1.8-3.007h1.143Z",
    transform: "translate(-65.814 -6.036)",
    fill: "#072132",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAltia);
export default __webpack_public_path__ + "static/media/logo__Altia.489d250412840dfac64348ba5d5f1a17.svg";
export { ForwardRef as ReactComponent };